import React, { useEffect } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Expertise } from './components/Expertise';
import { Achievements } from './components/Achievements';
import { Experience } from './components/Experience';
import { Certifications } from './components/Certifications';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Albert Previte Career Portfolio';
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-0" data-mp="31agoopp4khjz">
      <Navigation data-id="element-1" data-mp="2wjqhr811w6n6" />
      <main data-id="element-2" data-mp="2wj8dpp85co4p">
        <Hero data-id="element-3" data-mp="2wifhhi6tdh0t" />
        <About data-id="element-4" data-mp="2whxb3sqftmf6" />
        <Expertise data-id="element-5" data-mp="28ufqch5lbolp" />
        <Achievements data-id="element-6" data-mp="28tw4wqgqei2x" />
        <Experience data-id="element-7" data-mp="28te3zgj4jfoo" />
        <Certifications data-id="element-8" data-mp="28sl3uyeo7ofi" />
        <Contact data-id="element-9" data-mp="28s31dk1f0dz5" />
      </main>
      <Footer data-id="element-10" data-mp="23w4fc33k781w" />
    </div>;
}